import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useContent } from '../../content';
import BrochureCTA from '../BrochureCTA';

const Services = () => {
  const navigate = useNavigate();
  const { services } = useContent();
  return (
    <div className="grid lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] gap-12 lg:gap-16 items-start">
      {/* Left intro */}
      <div>
        <div className="label-mono text-ember mb-6">[{services.index}] · {services.label}</div>
        <h2 className="font-display font-light text-white text-3xl md:text-4xl lg:text-5xl leading-[1.1] tracking-tight">
          {services.headingLead}
          <span className="text-white/45">{services.headingMuted}</span>
        </h2>
        <div className="mt-8 w-16 h-px bg-ember/70" />
        <p className="mt-8 text-white/70 font-body text-base leading-relaxed">{services.body}</p>
        {/* Desktop: brochure sits in the left intro column */}
        <div className="hidden lg:block">
          <BrochureCTA />
        </div>
      </div>

      {/* Right service grid */}
      <div className="grid sm:grid-cols-2 gap-5">
        {services.items.map((s, i) => {
          const lastOdd = services.items.length % 2 === 1 && i === services.items.length - 1;
          return (
          <button
            key={s.no}
            onClick={() => navigate(`/services/${s.slug}`)}
            data-testid={`service-card-${s.no}`}
            className={`glass-card group text-left p-7 flex flex-col min-h-[190px] ${lastOdd ? 'sm:col-span-2' : ''}`}
          >
            <div className="flex items-start justify-between">
              <span className="label-mono text-ember">{s.no}</span>
              <ArrowUpRight size={18} className="text-white/40 transition-all group-hover:text-ember group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </div>
            <h3 className="mt-5 font-display font-medium text-white text-xl leading-snug">{s.title}</h3>
            <p className="mt-3 text-white/60 font-body text-sm leading-relaxed">{s.desc}</p>
          </button>
          );
        })}
      </div>

      {/* Mobile & tablet: brochure appears below the service tabs */}
      <div className="lg:hidden">
        <BrochureCTA />
      </div>
    </div>
  );
};

export default Services;
